var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户手机：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "搜索条件",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "mobile", $$v)
                      },
                      expression: "searchInfo.mobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "搜索条件",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.mainOrderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "mainOrderNo", $$v)
                      },
                      expression: "searchInfo.mainOrderNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "使用状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.ticketStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "ticketStatus", $$v)
                        },
                        expression: "searchInfo.ticketStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 0, attrs: { label: "未使用", value: 0 } },
                        [_vm._v("未使用")]
                      ),
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "已使用", value: 1 } },
                        [_vm._v("已使用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "券编号", prop: "ticketNo" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "券名称",
              prop: "ticketRule.ticketName",
              width: "300"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ticketRule.ruleType == 2 &&
                    scope.row.ticketRule.ticketType == 1
                      ? _c("span", [
                          _vm._v(
                            "【油品券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e(),
                    scope.row.ticketRule.ruleType == 2 &&
                    scope.row.ticketRule.ticketType == 2
                      ? _c("span", [
                          _vm._v(
                            "【油品券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e(),
                    scope.row.ticketRule.ruleType == 2 &&
                    scope.row.ticketRule.ticketType == 4
                      ? _c("span", [
                          _vm._v(
                            "【油品券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e(),
                    scope.row.ticketRule.ruleType == 3 &&
                    scope.row.ticketRule.ticketType == 1
                      ? _c("span", [
                          _vm._v(
                            "【商品券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e(),
                    scope.row.ticketRule.ruleType == 3 &&
                    scope.row.ticketRule.ticketType == 2
                      ? _c("span", [
                          _vm._v(
                            "【商品券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e(),
                    scope.row.ticketRule.ticketType == 3
                      ? _c("span", [
                          _vm._v(
                            "【现金券】" +
                              _vm._s(scope.row.ticketRule.ticketName)
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "用户手机", prop: "mobile" }
          }),
          _c("el-table-column", {
            attrs: { label: "是否使用", prop: "ticketStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ticketStatus == 0
                      ? _c("span", [_vm._v("未使用")])
                      : _vm._e(),
                    scope.row.ticketStatus == 1
                      ? _c("span", [_vm._v("已使用")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "消费单号", prop: "mainOrderNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "消费时间", prop: "useAt", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.useAt)))]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "发放渠道", prop: "ticketChannel" }
          }),
          _c("el-table-column", {
            attrs: { label: "发放来源", prop: "traceIdName" }
          }),
          _c("el-table-column", {
            attrs: { label: "券规则编号", prop: "ticketRuleNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看券规则")]
                    ),
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: "请问是否删除？" },
                        on: {
                          confirm: function($event) {
                            return _vm.deleteConfirm(scope.row)
                          }
                        }
                      },
                      [
                        scope.row.ticketStatus == 0
                          ? _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                staticStyle: { "margin-right": "2px" },
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  type: "danger"
                                },
                                slot: "reference"
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewOilFullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewOilFullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "券规则" } }),
                          _c("el-step", { attrs: { title: "可用油站" } }),
                          _c("el-step", { attrs: { title: "可用油品" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券面额：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.ticketValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketValue",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额/限升数：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("满升数可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("升可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.limitAddDiscount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddDiscount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddDiscount"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与其他油品优惠叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否可分享：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitShare,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitShare",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitShare"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可分享")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不可分享")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油站：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油站可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油站可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油站:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.stationCheckAll,
                                                callback: function($$v) {
                                                  _vm.stationCheckAll = $$v
                                                },
                                                expression: "stationCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.stationIdChecked,
                                                callback: function($$v) {
                                                  _vm.stationIdChecked = $$v
                                                },
                                                expression: "stationIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.stationOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.ID,
                                                  attrs: { label: item.ID }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.stationName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油品:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.oilCodesCheckAll,
                                                callback: function($$v) {
                                                  _vm.oilCodesCheckAll = $$v
                                                },
                                                expression: "oilCodesCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.oilCodesChecked,
                                                callback: function($$v) {
                                                  _vm.oilCodesChecked = $$v
                                                },
                                                expression: "oilCodesChecked"
                                              }
                                            },
                                            _vm._l(
                                              _vm.oilCodesOptions,
                                              function(oil) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: oil.value,
                                                    attrs: { label: oil.value }
                                                  },
                                                  [_vm._v(_vm._s(oil.label))]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("券规则描述")]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewOilDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewOilDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "油站配置" } }),
                          _c("el-step", { attrs: { title: "油品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "viewDiscountFormData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewOilDiscountDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券折扣：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("折")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("升可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最高优惠：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.maxDiscountValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "maxDiscountValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.maxDiscountValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加会员优惠：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.limitAddDiscount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddDiscount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddDiscount"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加其他券：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与任何折扣券叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("只能和本规则的券叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "最多叠加张数：" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否可分享：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitShare,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitShare",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitShare"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可分享")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不可分享")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "capital-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油站：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油站可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油站可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油站:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.stationCheckAll,
                                                callback: function($$v) {
                                                  _vm.stationCheckAll = $$v
                                                },
                                                expression: "stationCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.stationIdChecked,
                                                callback: function($$v) {
                                                  _vm.stationIdChecked = $$v
                                                },
                                                expression: "stationIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.stationOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.ID,
                                                  attrs: { label: item.ID }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.stationName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油品:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.oilCodesCheckAll,
                                                callback: function($$v) {
                                                  _vm.oilCodesCheckAll = $$v
                                                },
                                                expression: "oilCodesCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.oilCodesChecked,
                                                callback: function($$v) {
                                                  _vm.oilCodesChecked = $$v
                                                },
                                                expression: "oilCodesChecked"
                                              }
                                            },
                                            _vm._l(
                                              _vm.oilCodesOptions,
                                              function(oil) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: oil.value,
                                                    attrs: { label: oil.value }
                                                  },
                                                  [_vm._v(_vm._s(oil.label))]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewOilCashDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewOilCashDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "油站配置" } }),
                          _c("el-step", { attrs: { title: "油品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "viewCashFormData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewOilCashDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券面额：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("升可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否可分享：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitShare,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitShare",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitShare"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可分享")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不可分享")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "capital-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油站：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油站可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油站可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油站:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.stationCheckAll,
                                                callback: function($$v) {
                                                  _vm.stationCheckAll = $$v
                                                },
                                                expression: "stationCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.stationIdChecked,
                                                callback: function($$v) {
                                                  _vm.stationIdChecked = $$v
                                                },
                                                expression: "stationIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.stationOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.ID,
                                                  attrs: { label: item.ID }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.stationName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油品:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.oilCodesCheckAll,
                                                callback: function($$v) {
                                                  _vm.oilCodesCheckAll = $$v
                                                },
                                                expression: "oilCodesCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.oilCodesChecked,
                                                callback: function($$v) {
                                                  _vm.oilCodesChecked = $$v
                                                },
                                                expression: "oilCodesChecked"
                                              }
                                            },
                                            _vm._l(
                                              _vm.oilCodesOptions,
                                              function(oil) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: oil.value,
                                                    attrs: { label: oil.value }
                                                  },
                                                  [_vm._v(_vm._s(oil.label))]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewSingleDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewSingleDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "油站配置" } }),
                          _c("el-step", { attrs: { title: "油品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "viewDiscountFormData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewSingleDiscountDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券优惠：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元/升")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "加油满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("升可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最高优惠：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.maxDiscountValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "maxDiscountValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.maxDiscountValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加会员优惠：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.limitAddDiscount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddDiscount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddDiscount"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加其他券：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "最多叠加张数：" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否可分享：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitShare,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitShare",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitShare"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可分享")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不可分享")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "capital-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油站：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油站可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油站可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油站:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.stationCheckAll,
                                                callback: function($$v) {
                                                  _vm.stationCheckAll = $$v
                                                },
                                                expression: "stationCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.stationIdChecked,
                                                callback: function($$v) {
                                                  _vm.stationIdChecked = $$v
                                                },
                                                expression: "stationIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.stationOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.ID,
                                                  attrs: { label: item.ID }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.stationName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限油品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部油品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分油品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用油品:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.oilCodesCheckAll,
                                                callback: function($$v) {
                                                  _vm.oilCodesCheckAll = $$v
                                                },
                                                expression: "oilCodesCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.oilCodesChecked,
                                                callback: function($$v) {
                                                  _vm.oilCodesChecked = $$v
                                                },
                                                expression: "oilCodesChecked"
                                              }
                                            },
                                            _vm._l(
                                              _vm.oilCodesOptions,
                                              function(oil) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: oil.value,
                                                    attrs: { label: oil.value }
                                                  },
                                                  [_vm._v(_vm._s(oil.label))]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewGoodsFullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewGoodsFullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "券规则" } }),
                          _c("el-step", { attrs: { title: "可用便利店" } }),
                          _c("el-step", { attrs: { title: "可用商品" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券面额：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.ticketValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketValue",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额/限数量：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("满件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.limitAddDiscount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddDiscount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddDiscount"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与其他商品优惠叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("券规则描述")]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewGoodsDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewGoodsDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "券规则" } }),
                          _c("el-step", { attrs: { title: "可用便利店" } }),
                          _c("el-step", { attrs: { title: "可用商品" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券折扣：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.ticketValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketValue",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("折")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额/限数量：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("满件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最高优惠：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.maxDiscountValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "maxDiscountValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.maxDiscountValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.limitAddDiscount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddDiscount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddDiscount"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与其他商品优惠叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("券规则描述")]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewGoodsCashDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewGoodsCashDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewOilCashDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券面额：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "有效日期:" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每天时间:" } },
                                    [
                                      _c("el-time-picker", {
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm:ss",
                                          "value-format": "HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.timeRangeValueArr,
                                          callback: function($$v) {
                                            _vm.timeRangeValueArr = $$v
                                          },
                                          expression: "timeRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }